import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import BaiduMap from 'vue-baidu-map'
import SeoPlugin from '@/plugins/seo'

import '@/assets/css/index.less'
import 'hover.css'
import 'animate.css'

Vue.config.productionTip = false

Vue.use(ElementUI)
Vue.use(BaiduMap, {
  ak: 'YmkxRhdCOD6YaxFZpxBL5zfNFAprbUqF' // 必填项
})
Vue.use(SeoPlugin, { router })

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
